import { inject } from 'vue'
import type { AuthProvider } from '@/services/auth/auth-provider'
import { AuthProviderKey, getAuth } from '@/plugins/auth'

/**
 * Composable for accessing the auth provider in Vue components.
 * For non-component contexts (stores, interceptors), use `getAuth()` from `@/plugins/auth`.
 */
export function useAuth(): AuthProvider {
  return inject(AuthProviderKey) ?? getAuth()
}
